import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getPoolGroups(poolGroups) {
        await axios.get(requesturl() + "/api/latest/PoolGroup", {headers: {Authorization: window.$cookies.get("token")}})
            .then(res => {
                poolGroups(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async deletePoolGroup(poolGroup, response) {
        await axios.delete(requesturl() + "/api/latest/PoolGroup/" + poolGroup.poolGroupId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }

                response(responseObj);
            });
    },

    async postPoolGroup(poolGroup, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/PoolGroup',
            headers: headers,
            data: JSON.stringify(poolGroup)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };
            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    },

    async putPoolGroup(poolGroup, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'put',
            url: requesturl() + '/api/latest/PoolGroup/' + poolGroup.poolGroupId,
            headers: headers,
            data: JSON.stringify(poolGroup)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/poolgroupinterface.js